// 로그인 뒤 돌아갈 주소(?next=) 판정 — 2026-10-06 카카오 리퍼럴 광고 링크가 로그인에서 끊기던 문제.
// 사이트 안 주소만 허용한다: '/'로 시작, '//'(다른 도메인)·역슬래시·'/auth'(되돌이) 거부. 아니면 대시보드.
export function safeNextPath(raw: string | null): string {
    if (!raw || !raw.startsWith('/') || raw.startsWith('//') || raw.includes('\\') || raw.startsWith('/auth')) {
        return '/dashboard';
    }
    return raw;
}
